import request from '../functions/request'

// 支付
export function pay(params?: any) {
    return request<{
        data: unknown | null
        payStatus: null | string
        orderNo: string
        url: string | null
    }>({
      uri: '/api/business/member/pay/pay',
      params,
      method: 'POST',
      options: {
        // isShowMessage: false,
      },
    })
  }